import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/home/banner.png';
import _imports_1 from '@/assets/home/logo.png';
import _imports_2 from '@/assets/home/img1.png';
import _imports_3 from '@/assets/home/youshi1.png';
import _imports_4 from '@/assets/home/youshi2.png';
import _imports_5 from '@/assets/home/youshi3.png';
import _imports_6 from '@/assets/home/wall.png';
import _imports_7 from '@/assets/home/speed.png';
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "service content"
};
const _hoisted_3 = {
  class: "module"
};
const _hoisted_4 = {
  class: "service_menu"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "service_title"
};
const _hoisted_8 = ["src"];
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const serviceInd = ref(0);
    const serviceData = [{
      title: '证券业务解决方案',
      icon: require(`@/assets/home/icon_service1.png`),
      iconChoose: require(`@/assets/home/service_choose1.png`),
      img: require(`@/assets/home/service1.png`)
    }, {
      title: '基金业务支持',
      icon: require(`@/assets/home/icon_service2.png`),
      iconChoose: require(`@/assets/home/service_choose2.png`),
      img: require(`@/assets/home/service2.png`)
    }, {
      title: '期货专项服务',
      icon: require(`@/assets/home/icon_service3.png`),
      iconChoose: require(`@/assets/home/service_choose3.png`),
      img: require(`@/assets/home/service3.png`)
    }];
    const handleChange = index => {
      serviceInd.value = index;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"\" data-v-8e46fe52><div class=\"intro flex\" data-v-8e46fe52><div data-v-8e46fe52><img class=\"intro_logo\" src=\"" + _imports_1 + "\" alt=\"\" data-v-8e46fe52><p class=\"intro_desc\" data-v-8e46fe52> 作为扎根杭州的金融科技新锐企业，我们专注于为证券、基金、期货机构提供创新的技术解决方案。 </p></div><img class=\"intro_img\" src=\"" + _imports_2 + "\" alt=\"\" data-v-8e46fe52></div><div class=\"core content\" data-v-8e46fe52><div class=\"module\" data-v-8e46fe52><div class=\"module_title\" data-v-8e46fe52>核心优势</div><div class=\"flex core_img\" data-v-8e46fe52><img src=\"" + _imports_3 + "\" alt=\"\" data-v-8e46fe52><img src=\"" + _imports_4 + "\" alt=\"\" data-v-8e46fe52><img src=\"" + _imports_5 + "\" alt=\"\" data-v-8e46fe52></div></div></div>", 3)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "module_title"
      }, "产品服务体系", -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(serviceData, (item, index) => {
        return _createElementVNode("div", {
          class: _normalizeClass([serviceInd.value === index ? 'service_item_choose' : '', "service_item flex"]),
          key: index,
          onClick: $event => handleChange(index)
        }, [_createElementVNode("img", {
          class: "icon",
          src: serviceInd.value === index ? item.icon : item.iconChoose,
          alt: ""
        }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1)], 10, _hoisted_5);
      }), 64))]), _createElementVNode("img", {
        class: "service_img",
        src: serviceData[serviceInd.value].img,
        alt: ""
      }, null, 8, _hoisted_8)])]), _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"wall content\" data-v-8e46fe52><div class=\"module\" data-v-8e46fe52><div class=\"module_title\" data-v-8e46fe52>企业文化墙</div><img src=\"" + _imports_6 + "\" alt=\"\" data-v-8e46fe52></div></div><div class=\"speed content\" data-v-8e46fe52><div class=\"module\" data-v-8e46fe52><img src=\"" + _imports_7 + "\" alt=\"\" data-v-8e46fe52></div></div>", 2))]);
    };
  }
});